<template>
  <div>
    <label>
      <input type="checkbox" name="isChecked" v-model="control.isChecked">
      <span
        v-back-to-default="[
          $parent.inheritedControlInfo,
          control,
          'isChecked',
          $parent.backToDefault
        ]"
      />
      <span>Auto Checked?</span>
    </label>
  </div>
</template>

<script>
  export default {
    name: "CheckboxConfigComponent",
    props: {
      control: {
        type: Object
      },
    },
  }
</script>

<style scoped>

</style>
